import React from "react";
import { useQuery } from "react-query";
import { getGetJobs } from "../../../../actions/Utilities/JobConfig";

const useGetJobs = () => {
  return useQuery("GetJobs", getGetJobs, {
    refetchOnWindowFocus: false,
  });
};

export default useGetJobs;
